// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3uTRD","footer":"Form_footer__2br3m"};